import {
  FETCH_START,
  FETCH_END,
  GET_ALERTS_START,
  GET_ALERTS_SUCCESS,
  GET_ALERTS_FAIL,
  GET_ALERT_BY_ID_START,
  GET_ALERT_BY_ID_SUCCESS,
  GET_ALERT_BY_ID_FAIL,
  GET_ALERT_BY_NAME_START,
  GET_ALERT_BY_NAME_SUCCESS,
  GET_ALERT_BY_NAME_FAIL,
  CREATE_ALERT_START,
  CREATE_ALERT_SUCCESS,
  CREATE_ALERT_FAIL,
  UPDATE_ALERT_START,
  UPDATE_ALERT_SUCCESS,
  UPDATE_ALERT_FAIL,
  DELETE_ALERT_START,
  DELETE_ALERT_SUCCESS,
  DELETE_ALERT_FAIL,
  EXECUTE_ALERTS_START,
  EXECUTE_ALERTS_SUCCESS,
  EXECUTE_ALERTS_FAIL,
  GET_ATTRIBUTE_VALUES_START,
  GET_ATTRIBUTE_VALUES_SUCCESS,
  GET_ATTRIBUTE_VALUES_FAIL,
  GET_ALERTS_LIST_START,
  GET_ALERTS_LIST_SUCCESS,
  GET_ALERTS_LIST_FAIL,
} from './ActionTypes';
import axios from '../../../axios.conf';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};

// Get All Alerts
export const getAllAlerts = () => {
  return (dispatch) => {
    dispatch({ type: GET_ALERTS_START });
    dispatch(fetchStart());

    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };

    return axios
      .get('alert-management', { headers })
      .then(async (response) => {
        const data = response.data?.response || response.data || [];
        dispatch({
          type: GET_ALERTS_SUCCESS,
          data: Array.isArray(data) ? data : [],
        });
        dispatch(fetchEnd());

        const logNumber = response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      })
      .catch(async (error) => {
        const errorData = error?.response?.data || {};
        const errorMsg =
          errorData?.error ||
          errorData?.error?.message ||
          errorData?.message ||
          error?.message ||
          'Error fetching alerts';
        dispatch({
          type: GET_ALERTS_FAIL,
          error: errorMsg,
        });
        dispatch(fetchEnd());

        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
        throw error;
      });
  };
};

// Get Alert By ID
export const getAlertById = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_ALERT_BY_ID_START });
    dispatch(fetchStart());

    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };

    return axios
      .get('alert-management', {
        params: { id },
        headers,
      })
      .then(async (response) => {
        const data = response.data?.response || response.data;
        dispatch({
          type: GET_ALERT_BY_ID_SUCCESS,
          data,
        });
        dispatch(fetchEnd());

        const logNumber = response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      })
      .catch(async (error) => {
        const errorData = error?.response?.data || {};
        const errorMsg =
          errorData?.error ||
          errorData?.error?.message ||
          errorData?.message ||
          error?.message ||
          'Error fetching alert';
        dispatch({
          type: GET_ALERT_BY_ID_FAIL,
          error: errorMsg,
        });
        dispatch(fetchEnd());

        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
        throw error;
      });
  };
};

// Get Alert By Name
export const getAlertByName = (alertName) => {
  return (dispatch) => {
    dispatch({ type: GET_ALERT_BY_NAME_START });
    dispatch(fetchStart());

    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };

    return axios
      .get('alert-management', {
        params: { name: alertName },
        headers,
      })
      .then(async (response) => {
        const data = response.data?.response || response.data;
        dispatch({
          type: GET_ALERT_BY_NAME_SUCCESS,
          data,
        });
        dispatch(fetchEnd());

        const logNumber = response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      })
      .catch(async (error) => {
        const errorData = error?.response?.data || {};
        const errorMsg =
          errorData?.error ||
          errorData?.error?.message ||
          errorData?.message ||
          error?.message ||
          'Error fetching alert';
        dispatch({
          type: GET_ALERT_BY_NAME_FAIL,
          error: errorMsg,
        });
        dispatch(fetchEnd());

        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
        throw error;
      });
  };
};

// Create Alert
export const createAlert = (alertData) => {
  return (dispatch) => {
    dispatch({ type: CREATE_ALERT_START });
    dispatch(fetchStart());

    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
      'Content-Type': 'application/json',
    };

    return axios
      .post('alert-management', alertData, { headers })
      .then(async (response) => {
        const responseData = response.data || {};
        let message = 'Alert created successfully';
        let result = responseData;

        if (typeof responseData.response === 'string') {
          message = responseData.response;
          result = responseData.data || responseData;
        } else if (responseData.response) {
          result = responseData.response;
          message = responseData.message || message;
        }

        dispatch({
          type: CREATE_ALERT_SUCCESS,
          data: result,
          message: message,
        });
        dispatch(fetchEnd());
        dispatch(getAllAlerts());

        const logNumber = response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      })
      .catch(async (error) => {
        const errorData = error?.response?.data || {};
        const errorMsg =
          errorData?.error ||
          errorData?.error?.message ||
          errorData?.message ||
          error?.message ||
          'Error creating alert';
        dispatch({
          type: CREATE_ALERT_FAIL,
          error: errorMsg,
        });
        dispatch(fetchEnd());

        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
        throw error;
      });
  };
};

// Update Alert
export const updateAlert = (alertData) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_ALERT_START });
    dispatch(fetchStart());

    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
      'Content-Type': 'application/json',
    };

    return axios
      .put('alert-management', alertData, { headers })
      .then(async (response) => {
        const responseData = response.data || {};
        let message = 'Alert updated successfully';
        let result = responseData;

        if (typeof responseData.response === 'string') {
          message = responseData.response;
          result = responseData.data || responseData;
        } else if (responseData.response) {
          result = responseData.response;
          message = responseData.message || message;
        }

        dispatch({
          type: UPDATE_ALERT_SUCCESS,
          data: result,
          message: message,
        });
        dispatch(fetchEnd());
        dispatch(getAllAlerts());

        const logNumber = response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      })
      .catch(async (error) => {
        const errorData = error?.response?.data || {};
        const errorMsg =
          errorData?.error ||
          errorData?.error?.message ||
          errorData?.message ||
          error?.message ||
          'Error updating alert';
        dispatch({
          type: UPDATE_ALERT_FAIL,
          error: errorMsg,
        });
        dispatch(fetchEnd());

        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
        throw error;
      });
  };
};

// Delete Alert
export const deleteAlert = (id) => {
  return (dispatch) => {
    dispatch({ type: DELETE_ALERT_START });
    dispatch(fetchStart());

    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };

    return axios
      .delete(`alert-management/${id}`, { headers })
      .then(async (response) => {
        dispatch({
          type: DELETE_ALERT_SUCCESS,
          id,
        });
        dispatch(fetchEnd());
        dispatch(getAllAlerts());

        const logNumber = response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      })
      .catch(async (error) => {
        const errorData = error?.response?.data || {};
        const errorMsg =
          errorData?.error ||
          errorData?.error?.message ||
          errorData?.message ||
          error?.message ||
          'Error deleting alert';
        dispatch({
          type: DELETE_ALERT_FAIL,
          error: errorMsg,
        });
        dispatch(fetchEnd());

        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
        throw error;
      });
  };
};

// Execute Alerts
export const executeAlerts = (alertNames) => {
  return (dispatch) => {
    dispatch({ type: EXECUTE_ALERTS_START });
    dispatch(fetchStart());

    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
      'Content-Type': 'application/json',
    };

    return axios
      .post('alert-management/execute', { alert_names: alertNames }, { headers })
      .then(async (response) => {
        const data = response.data?.response || response.data;
        dispatch({
          type: EXECUTE_ALERTS_SUCCESS,
          data,
        });
        dispatch(fetchEnd());

        const logNumber = response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      })
      .catch(async (error) => {
        const errorData = error?.response?.data || {};
        const errorMsg =
          errorData?.error ||
          errorData?.error?.message ||
          errorData?.message ||
          error?.message ||
          'Error executing alerts';
        dispatch({
          type: EXECUTE_ALERTS_FAIL,
          error: errorMsg,
        });
        dispatch(fetchEnd());

        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
        throw error;
      });
  };
};

// Get Attribute Values
export const getAttributeValues = (attributeName) => {
  return (dispatch) => {
    dispatch({ type: GET_ATTRIBUTE_VALUES_START });
    dispatch(fetchStart());

    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
      'Content-Type': 'application/json',
    };

    axios
      .post('mdm/attribute-values', { attribute_name: attributeName }, { headers })
      .then((response) => {
        const data = response.data?.response || [];
        dispatch({
          type: GET_ATTRIBUTE_VALUES_SUCCESS,
          data: Array.isArray(data) ? data : [],
          attributeName,
        });
        dispatch(fetchEnd());
      })
      .catch((error) => {
        const errorData = error?.response?.data || {};
        const errorMsg =
          errorData?.error ||
          errorData?.error?.message ||
          errorData?.message ||
          error?.message ||
          `Error fetching attribute values for ${attributeName}`;
        dispatch({
          type: GET_ATTRIBUTE_VALUES_FAIL,
          error: errorMsg,
          attributeName,
        });
        dispatch(fetchEnd());
      });
  };
};

// Get Alerts List (from SQL workbench)
export const getAlertsList = () => {
  return (dispatch) => {
    dispatch({ type: GET_ALERTS_LIST_START });
    dispatch(fetchStart());

    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };

    axios
      .post('run-sql-work-bench/761', {}, { headers })
      .then((response) => {
        const data = response.data?.response || [];
        dispatch({
          type: GET_ALERTS_LIST_SUCCESS,
          data: Array.isArray(data) ? data : [],
        });
        dispatch(fetchEnd());
      })
      .catch((error) => {
        const errorData = error?.response?.data || {};
        const errorMsg =
          errorData?.error ||
          errorData?.error?.message ||
          errorData?.message ||
          error?.message ||
          'Error fetching alerts list';
        dispatch({
          type: GET_ALERTS_LIST_FAIL,
          error: errorMsg,
        });
        dispatch(fetchEnd());
      });
  };
};

